
const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {}

  return output
}

export default style
